export class IBookingSlot {
    _id: string;
    name: string;
    totalSlots: number;
    filledSlots: number;
    isDelete: boolean;
    isActive: boolean;
    startTime: Date;
    endTime: Date;
    branch: string;
    company: string;
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
}
